import { useLazyQuery, useMutation } from "@apollo/client/react";
import { gql } from "@apollo/client";
import toast from "react-hot-toast";
import { AuthorizationCheckRequired, eventBus, PmStore } from "@/state";





const queryGetApplication = gql`
  query application($organizationId: UUID!, $applicationId: UUID!) {
    application(organizationId: $organizationId, applicationId: $applicationId) {
     id
     id_friendly
     application_status
     application_status_id

     deposit_paid
     has_issues
     signed
     renewal_type
     renewal_type_id
     sms_consent_granted
     
     reservation {
      start_date
      end_date
      confirmed
     }
     
     pricing_plan {
      id
      name
      deposit {
       interval
       installments
       full_amount_in_dollars
      }
      rent {
       interval
       installments
       full_amount_in_dollars
      }
      one_time_payment {
       interval
       installments
       full_amount_in_dollars
      }
      
     }
     pm_status
     asset {
        id
        name
        owning_legal_entity_id
     }
    }
  }
`;




const queryApplicationTenants = gql`
    query applicationTenants($organizationId: UUID!, $applicationId: UUID!) {
    applicationTenants(organizationId: $organizationId, applicationId: $applicationId) {
     account_id
     account {
      first_name
      last_name
      phone_number
     }
     active
     auto_payment_amount_in_cents
     auto_payment_amount_in_dollars
     enable_auto_payment
     auto_payment_days_before_invoice_due
     payment_profile_id
     signed
    }
  }
`;


const mutationAcceptApplication = gql`
  mutation accept($organizationId: UUID!, $applicationId: UUID!) {
  acceptApplication( organizationId: $organizationId applicationId: $applicationId  )
 }
`;



const queryApplicationSearch = gql`
  query applicationSearch(
        $organizationId: UUID!, 
        $term: String!, 
        $page: Int!,
        $applicationId: UUID,
        $assets: [UUID!],
        $types:  [UUID!],
        $statuses:  [UUID!],
        $pmStatuses:  [UUID!],
        $accounts:  [UUID!],
        $locations:  [UUID!],
        $stages:  [UUID!],
     ) {
    applicationSearch(
        organizationId: $organizationId, 
        term: $term, 
        page: $page,
        applicationId: $applicationId,
        assets: $assets,
        types: $types,
        statuses: $statuses,
        pmStatuses: $pmStatuses,
        accounts: $accounts,
        locations:$locations,
        stages: $stages,
        ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      items {
        id
        address_full
        application_status
        application_stage
        application_type
        id_friendly
        pm_status
        asset_name
        
        tenants_signed
        deposit_paid
        submitter_name
        move_in
        move_out
        payments_pending
        unpaid_invoices
        
        created_ts
        updated_ts
        tenants {
          email
          first_name
          last_name
          phone_number
          signed
        }
      }
    }
  }
`;


export interface ApplicationSearchRequest {
    organizationId: string;
    term: string;
    page: number;
    applicationId: string;
    assets: [string];
    types: [string];
    stages: [string];
    pmStatuses: [string];
    accounts: [string];
    locations: [string];
    statuses: [string];
  }
  





export function useApplicationActions() {
    const state = PmStore();
    const [apiGetApplication] = useLazyQuery(queryGetApplication);
    const [apiApplicationTenants] = useLazyQuery(queryApplicationTenants);
    const [apiAcceptApplication] = useMutation(mutationAcceptApplication);
    const [apiApplicationSearch] = useLazyQuery(queryApplicationSearch);





  async function ApplicationSearch( params: ApplicationSearchRequest) {
    var variables: ApplicationSearchRequest = {
      ...params,
      organizationId: state?.selectedOrganization?.id as string
    };

    try {
      let result = await apiApplicationSearch({ variables}) as any;
      return result.data.applicationSearch as {};
    }
    catch (err) {
      toast.error("Api Error, Unable search applications");
    }
  }















    function AcceptApplication(applicationId: string) {

        let organizationId = state?.selectedOrganization?.id;
        return new Promise(async (resolve, reject) => {
            apiAcceptApplication({variables: {organizationId, applicationId}})
            .then((result: any) => result?.data?.acceptApplication)
            .then((result) => resolve(result))
            .catch((err) => {
                let data =  JSON.parse(JSON.stringify(err))
                if(data?.message?.includes("user is not authorized"))
                {
                    eventBus.next({type: AuthorizationCheckRequired})
                }

                if (err.name === 'AbortError') {
                // Handle aborted request gracefully
                return;
                }

                toast.error("Api Error, Unable to application tenants");
                reject(err);
            })
        })
    }




   
    function GetApplicationTenants(applicationId: string) {

        let organizationId = state?.selectedOrganization?.id;
        return new Promise(async (resolve, reject) => {
            apiApplicationTenants({variables: {organizationId, applicationId}})
            .then((result: any) => result?.data?.applicationTenants)
            .then((result) => resolve(result))
            .catch((err) => {
                let data =  JSON.parse(JSON.stringify(err))
                if(data?.message?.includes("user is not authorized"))
                {
                    eventBus.next({type: AuthorizationCheckRequired})
                }

                if (err.name === 'AbortError') {
                // Handle aborted request gracefully
                return;
                }

                toast.error("Api Error, Unable to application tenants");
                reject(err);
            })
        })
    }


    function GetApplication(applicationId: string) {
        if(!applicationId) throw "No Application selected";

        let organizationId = state?.selectedOrganization?.id;

        return new Promise(async (resolve, reject) => {
            apiGetApplication({variables: {organizationId, applicationId},})
            .then((result: any) => (result?.data?.application))
            .then((result) => resolve(result))
            .catch((err) => {
                let data =  JSON.parse(JSON.stringify(err))
                
                if(data?.message?.includes("user is not authorized"))
                {
                    eventBus.next({type: AuthorizationCheckRequired})
                }

                toast.error("Api Error, Unable to get application details");
                reject(err);
            })
        })
    }

    // function GetFlagsDefinition(organizationId: string) {
    //     if(!organizationId) throw "No organization selected";

    //     return new Promise(async (resolve, reject) => {
    //         apiGetFlagsDefinition()
    //         .then((result: any) => result?.data?.flagDefinitions)
    //         .then((result) => resolve(result))
    //         .catch((err) => {
    //             let data =  JSON.parse(JSON.stringify(err))
    //             if(data?.message?.includes("user is not authorized"))
    //             {
    //                 eventBus.next({type: AuthorizationCheckRequired})
    //             }

    //             toast.error("Api Error, Unable to get flag defintions");
    //             reject(err);
    //         })
    //     })
    // }


    
    return {
        GetApplication,
        GetApplicationTenants,
        AcceptApplication,
        ApplicationSearch
    };
}




